import { useEffect, useState } from "react";
import ArrowDownIcon from "../../../assets/arrow-down.svg?react";
import "./Collapsible.css";

interface CollapsibleProps {
    children?: React.ReactNode;
    title: string;
    titleClassName?: string;
    className?: string;
    icon?: React.ReactNode;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    onToggle?: () => void;
    headerContent?: React.ReactNode;
    messageWhenEmpty?: string;
}

const Collapsible = (props: CollapsibleProps) => {
    const {
        children,
        title,
        titleClassName,
        className,
        icon,
        isOpen,
        setIsOpen,
        onToggle,
        headerContent,
        messageWhenEmpty,
    } = props;
    const [internalIsOpen, setInternalIsOpen] = useState(isOpen);

    const clickHandler = () => {
        setIsOpen(!isOpen);
        setInternalIsOpen(!internalIsOpen);
        if (onToggle) {
            onToggle();
        }
    };

    useEffect(() => {
        setInternalIsOpen(isOpen);
    }, [isOpen]);

    return (
        <div className="nfs-collapsible-container">
            <button className={`nfs-collapsible-title ${className ?? ""}`} onClick={clickHandler}>
                <div className="flex-row space-between" style={{ width: "100%" }}>
                    <div className="flex-row small-gap center" style={{ overflow: "hidden" }}>
                        {icon}
                        <span title={title} className={`${titleClassName ?? ""}`}>
                            {title}
                        </span>
                    </div>
                    <ArrowDownIcon style={{ flexShrink: "0" }} className={internalIsOpen ? "rotate-180" : ""} />
                </div>
                {headerContent}
            </button>
            {internalIsOpen && (
                <div className="nfs-collapsible-content">
                    {children}
                    <div className="visible-when-alone">{messageWhenEmpty}</div>
                </div>
            )}
        </div>
    );
};

export default Collapsible;
